<div class="login">
  <mat-card class="login-card">
    <mat-card-header>
      <div class="logo-div">
        <img class="logo-img" [alt]="'logo-img'" [src]="LOGO" />
      </div>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="LoginForm">
        <div class="form-field">
          <mat-form-field class="Email login-form-field" appearance="outline">
            <mat-label>User Name</mat-label>
            <input
              formControlName="user_name"
              id="FormControlInput1"
              matInput
              placeholder="Enter your User Name"
              required
            />
          </mat-form-field>
        </div>
        <br />
        <div class="form-field">
          <mat-form-field
            class="password login-form-field"
            appearance="outline"
          >
            <mat-label>Password</mat-label>
            <input
              formControlName="password"
              id="FormControlInput2"
              required
              matInput
              [type]="hide ? 'password' : 'text'"
            />
            <button
              mat-icon-button
              matSuffix
              (click)="hide = !hide"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide"
            >
              <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </form>
      <span *ngIf="errorMessage">{{errorMessage}}</span>
    </mat-card-content>
    <button
      mat-flat-button
      type="submit"
      class="login-btn bs-teal"
      [disabled]="LoginForm.invalid"
      (click)="Login()"
    >
      Login
    </button>
  </mat-card>
</div>
